import styled from "styled-components";

import { breakpoints } from "@/styles/breakpoints";

export const StyledBreadcrumbs = styled.nav`
    display: flex;
    flex-wrap: nowrap;
    align-items: center;
    /* margin-bottom: 2rem; MYBR-6934*/

    .bc {
        display: flex;
        align-items: center;
        margin-right: 10px;
        font-size: var(--size-14);
        font-weight: normal;
        color: var(--color-grey-800);
        background-color: transparent;
        min-width: 0;

        @media ${breakpoints.xs} {
            min-width: 48px;
            margin-right: 5px;
        }

        .breadcrumbsName {
            margin-right: 15px;
            font-size: var(--size-14);
            font-weight: normal;
            line-height: 24px;
            color: var(--color-grey-800);
            white-space: nowrap;
            overflow: hidden;
            text-overflow: ellipsis;
            flex-grow: 1;
            cursor: pointer;

            @media ${breakpoints.xs} {
                margin-right: 5px;
            }

            &:hover {
                text-decoration: none;
            }
        }

        .breadcrumbRafter {
            min-width: 24px;
            min-height: 24px;
        }
    }

    .bc:last-child {
        margin-right: 0px;

        .breadcrumbsName {
            margin-right: 0px;
        }
    }
`;
